export const apiAccessToken =
    'pk.eyJ1Ijoid2VuZ2M3IiwiYSI6ImNsNWMzeHk3aDA2ajIzcHIwd2o0NDZtNm0ifQ.4LNnamoJCcVQbDzcouxjfw'
export const mapStyle = 'https://vectortiles.geo.admin.ch/styles/ch.swisstopo.leichte-basiskarte.vt/style.json';
export const mapStyleImagery ="mapbox://styles/mapbox/streets-v11";
export const mapStyleSwiss =
    'https://vectortiles.geo.admin.ch/styles/ch.swisstopo.leichte-basiskarte-imagery.vt/style.json';
